<template>
  <div class="info-box">
    <div class="flex-1 overflow-y-auto gap-x-3">
      <el-form
        :model="state.model"
        label-width="auto"
        label-position="top"
        ref="formDom"
        size="large"
        class="px-2.5"
      >
        <el-form-item label="服务类型">
          <el-radio-group v-model="state.model.type" @change="onTypeChange">
            <el-radio-button
              v-for="item in $base.Meeting_Pickup_Car_Type"
              :key="item.Key"
              :value="item.Key"
              >{{ item.Text }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="乘客"
          prop="meeting_attendee"
          :rules="[{ required: true, message: '请选择乘客', trigger: 'blur' }]"
        >
          <el-select
            v-model="state.model.meeting_attendee"
            value-key="id"
            @change="onRyChange"
            :disabled="!state.model.type"
          >
            <template #label="{ label, value }">
              <div class="flex w-full gap-x-5 items-center">
                <text>{{ ry_map.get(value)?.conferee?.name }}</text>
                <text>{{ ry_map.get(value)?.conferee?.phone }}</text>
                <li class="flex-1"></li>
                <c_status
                  arrName="Meeting_Attend_Type"
                  :value="ry_map.get(value)?.attend_type"
                  :key="ry_map.get(value)?.attend_type"
                ></c_status>
              </div>
            </template>
            <el-option
              v-for="item in state.ry_data"
              :key="item"
              :label="`${item.conferee.name} ${item.conferee.phone}`"
              :value="item.id"
            >
              <div class="flex w-full gap-x-5 items-center">
                <text>{{ item.conferee?.name }}</text>
                <text>{{ item.conferee?.phone }}</text>
                <li class="flex-1"></li>
                <c_status
                  arrName="Meeting_Attend_Type"
                  :value="item.attend_type"
                  :key="item.attend_type"
                ></c_status>
              </div>
            </el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadRy()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="[1, 2].includes(state.model.type)"
          label="航班/车次"
        >
          <el-select
            v-model="state.model.meeting_transport_ticket"
            value-key="id"
            :disabled="!state.model.type || !state.model.meeting_attendee"
          >
            <template #label="{ label, value }">
              <div class="flex w-full gap-x-2 items-center">
                <c_status
                  arrName="Meeting_Transport_Ticket_Type"
                  :value="value.ticket_type"
                  :key="value.ticket_type"
                ></c_status>
                <text>{{ value.transport_no }}</text>
                <text>{{
                  $dayjs(value.departure_time).format("YYYY-MM-DD HH:mm")
                }}</text>
                <text>{{ value.departure_name }}</text>
                <text> - </text>
                <text>{{
                  $dayjs(value.arrival_time).format("YYYY-MM-DD HH:mm")
                }}</text>
                <text>{{ value.arrival_name }}</text>
              </div>
            </template>
            <el-option
              v-for="item in state.pj_data"
              :key="item"
              :label="item.name"
              :value="item"
            >
              <div class="flex w-full gap-x-2 items-center">
                <c_status
                  arrName="Meeting_Transport_Ticket_Type"
                  :value="item.ticket_type"
                  :key="item.ticket_type"
                ></c_status>
                <text>{{ item.transport_no }}</text>
                <text>{{
                  $dayjs(item.departure_time).format("YYYY-MM-DD HH:mm")
                }}</text>
                <text>{{ item.departure_name }}</text>
                <text>~</text>
                <text>{{
                  $dayjs(item.arrival_time).format("YYYY-MM-DD HH:mm")
                }}</text>
                <text>{{ item.arrival_name }}</text>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="接客时间"
          prop="c_reception_time"
          :rules="[
            { required: true, message: '请选择接客时间', trigger: 'blur' },
          ]"
        >
          <div class="grid items-center gap-x-2 grid-cols-2">
            <el-date-picker
              v-model="state.model.c_reception_date"
              type="date"
              placeholder="接客日期"
              value-format="YYYY-MM-DD"
              class="!w-full"
            />
            <el-time-picker
              v-model="state.model.c_reception_time"
              placeholder="时间"
              value-format="HH:mm:ss"
              format="HH:mm"
              class="!w-28"
              :save-on-blur="false"
            />
          </div>
        </el-form-item>
        <el-form-item
          label="接客地点"
          prop="reception_place"
          :rules="[
            { required: true, message: '请选择接客地点', trigger: 'blur' },
          ]"
        >
          <el-select
            v-if="state.model.type == 1"
            v-model="state.model.reception_place"
            filterable
            allow-create
            default-first-option
            placeholder="出发地点"
            :clearable="false"
          >
            <el-option
              v-for="option in state.jsdd_data"
              :key="option.name"
              :label="option.name"
              :value="option.name"
            ></el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadJsdd()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
          <el-input
            v-else
            v-model="state.model.reception_place"
            placeholder="接客地点"
          />
        </el-form-item>
        <el-form-item
          label="预计送达"
          prop="c_estimate_send_time"
          :rules="[
            { required: true, message: '请选择送达时间', trigger: 'blur' },
          ]"
        >
          <div class="grid items-center gap-x-2 grid-cols-2">
            <el-date-picker
              v-model="state.model.c_estimate_send_date"
              type="date"
              placeholder="送达日期"
              value-format="YYYY-MM-DD"
              class="!w-full"
            />
            <el-time-picker
              v-model="state.model.c_estimate_send_time"
              placeholder="时间"
              value-format="HH:mm:ss"
              format="HH:mm"
              class="!w-28"
              :save-on-blur="false"
            />
          </div>
        </el-form-item>
        <el-form-item
          label="送达地点"
          prop="send_place"
          :rules="[
            { required: true, message: '请输入送达地点', trigger: 'blur' },
          ]"
        >
          <el-select
            v-if="state.model.type == 2"
            v-model="state.model.send_place"
            filterable
            allow-create
            default-first-option
            placeholder="送达地点"
            :clearable="false"
          >
            <el-option
              v-for="option in state.jsdd_data"
              :key="option.name"
              :label="option.name"
              :value="option.name"
            ></el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadJsdd()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
          <el-input
            v-model="state.model.send_place"
            placeholder="送达地点"
            v-else
          />
        </el-form-item>
        <el-form-item label="接送说明">
          <el-input
            v-model="state.model.pickup_intro"
            type="textarea"
            :autosize="{
              minRows: 4,
            }"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="primary" @click="onSubmit"> 提交 </el-button>
    </div>
    <el-image-viewer
      v-if="state.showPreview"
      :url-list="state.model.files?.map((m) => m.file_url)"
      show-progress
      :initial-index="4"
      @close="state.showPreview = false"
    />
  </div>
</template>

<script>
import { onMounted, reactive, ref, computed } from "vue";
import { data_getMeetingAttendee, dic_getPickupPlace } from "@/http/data";
import {
  meeting_service_pickup_car_getAttendeeTicketList,
  meeting_service_pickup_car_arrange,
} from "@/http/meetingservice";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    meeting_id: Number,
    meeting_car: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        meeting_id: props.meeting_id,
        meeting_car_id: props.meeting_car?.id,
        type: 1,
      },
    });
    onMounted(() => {
      onLoadRy();
      onLoadJsdd();
    });

    //获取人员
    const onLoadRy = () => {
      data_getMeetingAttendee({
        limit: 0,
        meeting_id: props.meeting_id,
      }).then((res) => {
        if (res.status == 200) state.ry_data = res.data?.data?.list || [];
      });
    };

    //供应商账户 id 索引，O(1) 查找
    const ry_map = computed(() => {
      const m = new Map();
      state.ry_data?.forEach((item) => m.set(item.id, item));
      return m;
    });

    //人员选择事件
    const onRyChange = (val) => {
      delete state.model.meeting_transport_ticket;
      if ([1, 2].includes(state.model?.type)) {
        meeting_service_pickup_car_getAttendeeTicketList({
          limit: 0,
          meeting_attendee_id: ry_map.value.get(val).conferee_id,
          pickup_type: state.model.type,
          arrival_time:
            props.meeting_car?.service_time_start +
            " ~ " +
            props.meeting_car?.service_time_end,
        }).then((res) => {
          if (res.status == 200) {
            state.pj_data = res.data?.data?.list || [];
          }
        });
      }
    };

    //获取接送地点
    const onLoadJsdd = () => {
      dic_getPickupPlace().then((res) => {
        if (res.status == 200) state.jsdd_data = res.data.data;
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          state.model.meeting_attendee_id = state.model.meeting_attendee?.id;
          state.model.meeting_transport_ticket =
            state.model.meeting_transport_ticket?.id;

          state.model.reception_time =
            state.model.c_reception_date + " " + state.model.c_reception_time;
          state.model.estimate_send_time =
            state.model.c_estimate_send_date +
            " " +
            state.model.c_estimate_send_time;

          //倒查接送地点
          const d_pickup_place_reception = state.jsdd_data.find(
            (w) => w.name == state.model?.reception_place,
          );

          if (d_pickup_place_reception) {
            state.model.d_pickup_place_reception_id =
              d_pickup_place_reception.id;
          }

          //倒查接送地点
          const d_pickup_place_send = state.jsdd_data.find(
            (w) => w.name == state.model?.send_place,
          );

          if (d_pickup_place_send) {
            state.model.d_pickup_place_send_id = d_pickup_place_send.id;
          }

          meeting_service_pickup_car_arrange(state.model).then((res) => {
            post_response(res, () => {
              setTimeout(() => {
                emit("close", true);
              }, 500);
            });
          });
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
      onRyChange,
      ry_map,
    };
  },
};
</script>
<style scoped></style>
